import { initialEnrollmentSnapshot } from './enrollmentDefaults'
import type { EnrollmentSnapshot } from './enrollmentState.types'

export const ENROLLMENT_STORAGE_KEY = 'enrollment-storage'

export const readPersistedEnrollmentSnapshot = (): EnrollmentSnapshot => {
  return initialEnrollmentSnapshot
}

export const writePersistedEnrollmentSnapshot = (_snapshot: EnrollmentSnapshot) => {}

export const clearPersistedEnrollmentSnapshot = () => {
  if (typeof window === 'undefined') return
  window.sessionStorage.removeItem(ENROLLMENT_STORAGE_KEY)
  window.localStorage.removeItem(ENROLLMENT_STORAGE_KEY)
}
